<form
  [formGroup]="manufactureForm"
  class="manufacture-section rx-app-flex-container-row rx-app-flex-container-row--justify-space-between"
  [class.read-only]="isReadOnly"
>
    <rx-favorite-selector
            class="manufacture-section__field"
            [id]="'scan-body-manufacturer'"
            [label]="'ToothEditor.ScanBodyManufacturer' | translate"
            [isRequired]="shouldValidateForSend$ | async"
			[isCancellable]="(shouldValidateForSend$ | async) === false && isProcedureFlow"
            [formControl]="scanBodyManufacturerControl"
            [isReadOnly]="isReadOnly"
            [options]="scanBodyManufacturerOptions$ | async"
            [favoriteName]="favoriteScanBody"
            name="scanBodyManufacturerControl"
            [enableSimpleMode]="isFavoritesHidden$ | async"
    ></rx-favorite-selector>
    <rx-favorite-selector
            class="manufacture-section__field"
            [id]="'implant-manufacturer'"
            [label]="'ToothEditor.ImplantManufacturer' | translate"
            [isReadOnly]="isReadOnly"
            [isRequired]="shouldValidateForSend$ | async"
			[isCancellable]="(shouldValidateForSend$ | async) === false && isProcedureFlow"
            [formControl]="implantManufacturerControl"
            [options]="implantManufacturerOptions"
            [isDisabled]="!implantManufacturerOptions?.length"
            [favoriteName]="favoriteImplant"
            name="implantManufacturerControl"
            [enableSimpleMode]="isFavoritesHidden$ | async"
    ></rx-favorite-selector>
	<rx-select
			class="manufacture-section__field"
			[id]="'implant-type-scan-body'"
			[label]="'ToothEditor.ImplantTypeScanBody' | translate"
			[isDisabled]="!implantTypeScanBodyOptions?.length || isReadOnly"
			[isRequired]="shouldValidateForSend$ | async"
			[isCancellable]="(shouldValidateForSend$ | async) === false && isProcedureFlow"
			[formControl]="implantTypeScanBodyControl"
			[options]="implantTypeScanBodyOptions"
			[dropdownPositions]="'right'"
			[panelClass]="'implant-type-scan-body-panel'"
	></rx-select>
</form>
